/**
 * Compte de démonstration pour la revue App Store / Google Play.
 *
 * L'app s'authentifie par OTP email : un relecteur ne peut pas recevoir le code
 * envoyé par mail. Ce compte UNIQUE se connecte donc avec un code FIXE via
 * l'écran de login habituel — la session est frappée côté serveur par l'edge
 * function `test-account-login` (voir supabase/functions/test-account-login).
 *
 * Aucun autre compte n'est concerné : le flux OTP normal reste inchangé.
 */

import { supabase } from './supabase';

export const TEST_ACCOUNT_EMAIL = 'app_tester@jeraisonne.fr';
export const TEST_ACCOUNT_OTP = '123456';

/** Vrai si l'email saisi est celui du compte de démonstration (insensible à la casse). */
export function isTestAccountEmail(email: string): boolean {
  return email.trim().toLowerCase() === TEST_ACCOUNT_EMAIL;
}

/**
 * Connecte le compte de démonstration : appelle l'edge function (qui valide le
 * code fixe et renvoie une session) puis installe la session localement.
 * `onAuthStateChange` prend le relais pour la redirection.
 *
 * @returns `true` si la connexion a réussi, `false` sinon (code refusé, réseau…).
 */
export async function loginTestAccount(code: string): Promise<boolean> {
  const { data, error } = await supabase.functions.invoke<{
    access_token?: string;
    refresh_token?: string;
  }>('test-account-login', {
    body: { email: TEST_ACCOUNT_EMAIL, code },
  });

  if (error || !data?.access_token || !data?.refresh_token) return false;

  const { error: sessionError } = await supabase.auth.setSession({
    access_token: data.access_token,
    refresh_token: data.refresh_token,
  });
  return !sessionError;
}
